import React from "react";

const TestimonialAreaThreeItem = ({ item }) => {
  return (
    <div className="swiper-slide">
      <div className="testimonial-item-three">
        <div className="testimonial-thumb-three">
          <img src={item.img} alt={`Review door ${item.name}`} />
        </div>
        <div className="testimonial-content-three">
          <h4 className="title">{item.name}</h4>
          <span>{item.role}</span>
          <p>“{item.text}”</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialAreaThreeItem;
